import {
  SET_PORTAL_NOTIFICATIONS,
  PORTAL_NOTIFICATIONS_DECREMENT_UNREAD_COUNT,
  PORTAL_NOTIFICATIONS_INCREMENT_UNREAD_COUNT,
} from './types';

interface PortalNotificationsState {
  unreadCount: number;
}

const initialState: PortalNotificationsState = {
  unreadCount: 0,
};

export const portalNotificationsReducer = (state = initialState, action: any): PortalNotificationsState => {
  switch (action.type) {
    case SET_PORTAL_NOTIFICATIONS:
      return { ...state, ...action.payload };
    case PORTAL_NOTIFICATIONS_INCREMENT_UNREAD_COUNT:
      return { ...state, unreadCount: state.unreadCount + 1 };
    case PORTAL_NOTIFICATIONS_DECREMENT_UNREAD_COUNT:
      return { ...state, unreadCount: state.unreadCount > 0 ? state.unreadCount - 1 : 0 };
    default:
      return state;
  }
};
